import React from "react";
import {
  MDBSpinner,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBChip,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBIcon, MDBCol, MDBRow, MDBInput
} from 'mdbreact';
import StorageLink from './StorageLink'
import firebase from "../../firebase";
import { getTypesenseClient } from "../../utils/typesenseClient";
import DataGrid, {
  Column,
  ColumnChooser,
  Paging,
  FilterRow, ColumnFixing, Scrolling,Export,Pager,ColumnChooserSearch,Sorting
} from "devextreme-react/data-grid";
import {Workbook} from 'exceljs';
import {saveAs} from "file-saver";
import {exportDataGrid} from 'devextreme/excel_exporter';
import report from "./Report";

class ReportTableListV2 extends React.Component {
  constructor(props) {
    super(props);
    this.dataGrid = null
    this.state = {
      loading: false,
      dbReports: [],
      last: null,
      reportPerPage: 12,
      searchwordA: '',
      algoriaPage: 1,
      algolia: false,
      sortType: 'desc',
      reportsType: '1',
    }
  }

  getReportsA = async (props, newOrg, word) => {
    if (this.state.loading) {
      return;
    }

    if(props.org){
    } else{
      return;
    }
    if (this.state.notMore) {
      return;
    }
    let fromOrg = "";
    let toOrg = "";
    let urigawa = false;
    let indexName = 'P4Report'

    if(props.userOrg && props.userOrg.maker) {
      fromOrg = props.user.organization;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.buyer) {
      fromOrg = props.user.organization;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.maker) {
      fromOrg = props.org.id;
      toOrg = props.user.organization;
    }
    if(props.userOrg && props.userOrg.buyer && props.org && props.org.reseller) {
      fromOrg = props.org.id;
      toOrg = props.user.organization;
    }
    if (fromOrg == ""){
      return;
    }

    let tempResults = [];

    this.setState({loading: true, algolia: true});
    let filters = `fromOrganization:${fromOrg} && toOrganization:${toOrg}`

    if (!urigawa) {
      filters += ` && deleted:false`
    } else {
      switch (this.state.reportsType) {
        case '1':
          filters += ` && deleted:false`;
          break;
        case '2':
          filters += ` && deleted:true`;
          break;
      }
    }
    let searchParameters = {
      'q'         : word,
      'query_by'  : '*',
      'filter_by' : filters,
      'sort_by'   : this.state.sortType === 'desc' ? 'dueDate:desc' : 'dueDate:asc',
      'page'      : this.state.algoriaPage,
      'per_page'  : this.state.reportPerPage
    }
    try {
      await (await getTypesenseClient()).collections('report').documents().search(searchParameters).then((docs) => {
        docs.hits.forEach((data) => {
          tempResults.push(data.document);
        })
      });
    } catch (e) {
      console.error('[typesense] report search failed', e);
      this.setState({ loading: false });
      return;
    }
    let nextPage = this.state.algoriaPage + 1;
    let newResults = this.state.dbReports.concat(tempResults);
    let notMore = false;
    if (newResults.length === 0) {
      notMore = true
    }
    this.setState({algoriaPage: nextPage,dbReports:newResults,loading:false,notMore: notMore})
  }

  getReports = (props, newOrg) => {
    // console.log("###### getReports ########", props)

    if (this.state.loading) {
      return;
    }

    if(props.org){
    } else{
      return;
    }
    if (this.state.notMore) {
      return;
    }
    let fromOrg = "";
    let toOrg = "";
    let urigawa = false;

    if(props.userOrg && props.userOrg.maker) {
      fromOrg = props.user.organization;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.buyer) {
      fromOrg = props.user.organization;
      toOrg = props.org.id;
      urigawa = true;
    }
    if(props.userOrg && props.userOrg.reseller && props.org && props.org.maker) {
      fromOrg = props.org.id;
      toOrg = props.user.organization;
    }
    if(props.userOrg && props.userOrg.buyer && props.org && props.org.reseller) {
      fromOrg = props.org.id;
      toOrg = props.user.organization;
    }
    if (fromOrg == ""){
      return;
    }

    // let s = this.props.db.collection('report').orderBy('created', 'desc');
    // s.get().then((snapshot) => {
    //   console.log(snapshot.docs.length);
    //   snapshot.forEach((doc) => {
    //     let data = doc.data();
    //     console.log(data)
    //     if (data.deleted && data.deleted !== true) {
    //       console.log('deleted true',data);
    //       this.props.db.collection('report').doc(doc.id).update({deleted: true});
    //     }
    //
    //     if (!data.deleted && data.deleted !== false) {
    //       console.log('deleted false',data)
    //       this.props.db.collection('report').doc(doc.id).update({deleted: false});
    //     }
    //   })
    // });

    let first;
    this.setState({loading: true, algolia: false})

    if (urigawa) {
      switch (this.state.reportsType) {
        case '1':
          if(this.state.last){
            first = this.props.db.collection('report')
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where("deleted", "==", false)
                .orderBy('dueDate',this.state.sortType)
                .startAfter(this.state.last)
                .limit(this.state.reportPerPage);
          }else{
            first = this.props.db.collection("report")
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where("deleted", "==", false)
                .orderBy('dueDate',this.state.sortType)
                .limit(this.state.reportPerPage);
          }
          break;
        case '2':
          if(this.state.last){
            first = this.props.db.collection('report')
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where("deleted", "==", true)
                .orderBy('dueDate',this.state.sortType)
                .startAfter(this.state.last)
                .limit(this.state.reportPerPage);
          }else{
            first = this.props.db.collection("report")
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .where("deleted", "==", true)
                .orderBy('dueDate',this.state.sortType)
                .limit(this.state.reportPerPage);
          }
          break;
        default:
          if(this.state.last){
            first = this.props.db.collection('report')
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .orderBy('dueDate',this.state.sortType)
                .startAfter(this.state.last)
                .limit(this.state.reportPerPage);
          }else{
            first = this.props.db.collection("report")
                .where("fromOrganization", "==", fromOrg)
                .where("toOrganization", "==", toOrg)
                .orderBy('dueDate',this.state.sortType)
                .limit(this.state.reportPerPage);
          }
          break;
      }
    } else {
      if(this.state.last){
        first = this.props.db.collection('report')
            .where("fromOrganization", "==", fromOrg)
            .where("toOrganization", "==", toOrg)
            .where("deleted", "==", false)
            .orderBy('dueDate',this.state.sortType)
            .startAfter(this.state.last)
            .limit(this.state.reportPerPage);
      }else{
        first = this.props.db.collection("report")
            .where("fromOrganization", "==", fromOrg)
            .where("toOrganization", "==", toOrg)
            .where("deleted", "==", false)
            .orderBy('dueDate',this.state.sortType)
            .limit(this.state.reportPerPage);
      }
    }


    let paginate = first.get()
    .then((snapshot) => {
      this.setState({loading: false})
      if(snapshot.docs.length > 0) {
        let last = snapshot.docs[snapshot.docs.length - 1];

        this.setState({last: last})


        let reports = this.state.dbReports;

        if (newOrg === true) {
          reports = [];
        }

        snapshot.forEach((doc) => {
          let data = doc.data();
          data.id = doc.id;
          reports.push(data)
        })
        this.setState({dbReports: reports}, () => {
          let wrapper1 = document.getElementById('wrapper1');
          let div1 = document.getElementById('div1');
          let wrapper2 = document.getElementsByClassName('table-responsive')[0];
          let div2 = document.getElementById('div2');

          if (wrapper1 && div1 && wrapper2 && div2) {
            div1.style.width = div2.offsetWidth+'px';

            wrapper1.onscroll = function() {
              wrapper2.scrollLeft = wrapper1.scrollLeft;
            };
            wrapper2.onscroll = function() {
              wrapper1.scrollLeft = wrapper2.scrollLeft;
            };
          }
        })
      }else{
        this.setState({notMore: true, loading: false});
        if (newOrg === true) {
          this.setState({dbReports: []})
        }
      }

    });

  }

  componentDidMount() {
    //this.getReports();
    this.getReports(this.props, true);
    this.props.loadBadge();
   // window.addEventListener('scroll', event => this.watchCurrentPosition(), true);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({last: null, dbReports: []}, () => {
      this.getReports(nextProps, true);
      this.props.loadBadge();
    })
  }
  componentWillUnmount() {
    //window.removeEventListener('scroll', event => this.watchCurrentPosition(), true);
  }

  /*watchCurrentPosition() {
    if(window.innerHeight + this.scrollTop() +20 >= document.body.clientHeight) {
      console.log('reach end');
      this.onReachEnd();
    }
  }*/

  scrollTop() {
    return Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
        );
  }

  onReachEnd = () => {
    console.log("LAST:" , this.state.last);
    if(this.state.algolia){
      this.getReportsA(this.props, false, this.state.searchwordA);
    } else {
      this.getReports(this.props, false);
    }
  }

  openFile = (e) => {
    console.log("openFile:" , e.currentTarget.dataset.id);

    let esId = e.currentTarget.dataset.id;
    let urigawa = e.currentTarget.dataset.urigawa;
    let index = e.currentTarget.dataset.index;
    urigawa = urigawa === 'true'

    let item = this.state.dbReports[index];

    let reportSet = {
      visited: {[this.props.user.id]: true},
    }
    if (!urigawa) {
      let date = firebase.firestore.Timestamp.fromDate(new Date())

      if (!item.confirmDate && !(item['visited'] && item['visited'][item['toUser']])) {
        reportSet.confirmDate = date
        reportSet.confirmUser = this.props.user.id;
        reportSet.confirmUserName = this.props.user.last_name + this.props.user.first_name;
        this.dbReportUpdate(esId,"confirmDate",date);
        this.dbReportUpdate(esId,"confirmUserName",this.props.user.last_name + this.props.user.first_name);
      }

      if (item.readBuyer === false) {
        reportSet.readBuyer = true;
        this.dbReportUpdate(esId, "readBuyer", true);
        this.props.readReport(1)
      }
    } else {
      if (item.readSeller === false) {
        reportSet.readSeller = true;
        this.dbReportUpdate(esId, "readSeller", true);
        this.props.readReport(1)
      }
    }

    let reportRef = this.props.db.collection('report').doc(esId);
    reportRef.set(reportSet, { merge: true });
    this.dbReportUpdate(esId,"visited",{[this.props.user.id]:true});
  }

  delete = (e) => {
    let esId = e.currentTarget.dataset.id;
    let esTitle = e.currentTarget.dataset.title;

    this.setState({
      deleteModal: true,
      deleteId: esId,
      deleteTitle: esTitle,
    })
  }

  deleteClose = (e) => {
    this.setState({
      deleteModal: false,
      deleteId: null,
      deleteTitle: null,
    });

    let esId = e && e.currentTarget.dataset.id;
    if(esId){
      let date = firebase.firestore.Timestamp.fromDate(new Date())

      let billsRef = this.props.db.collection('report').doc(esId);
      billsRef.set({
        deleted: true,
        deletedUser: this.props.user.id,
        deletedUserName: this.props.user.last_name + this.props.user.first_name,
        deletedDate: date
      }, { merge: true });
      this.dbReportUpdate(esId,"deleted",{key:1});
    }
  }

  dbReportUpdate = (id,target,value) => {
    let dbReportUpdated = this.state.dbReports.map((es)=>{
      if(es.id === id){
        if(target === 'visited') {
          let visited = es.visited;
          if(visited){
            es[target] = Object.assign(visited, value);
          } else {
            es[target] = value;
          }
        }else{
          es[target] = value;
        }
      }
      return es;
    })
    this.setState({
      dbReports: dbReportUpdated,
    })
  }

  handleSearchwordAChange = (e) => {
    this.setState({
      searchwordA: e.currentTarget.value,
    });
  }

  handleSearchwordAKeyDown = (e) => {
    let val = this.state.searchwordA;
    if (e.key === 'Enter') {
      this.setState({
        dbReports: [],
        last: null,
        algoriaPage: 1,
      }, ()=>{
        if (val) {
          this.getReportsA(this.props, true, val);
        } else {
          this.getReports(this.props, true)
        }
      });
    }
  }

  sortChange = (val) => {
    this.setState({last: null, notMore: false, sortType: val, dbReports: [], algoriaPage: 1}, () => {
      if (this.state.algolia) {
        this.getReportsA(this.props, true, this.state.searchwordA);
      } else {
        this.getReports(this.props, true);
      }

    })
  }

  selectReportsType = (e) => {
    this.setState({
      reportsType: e.target.value || '1',
      last: null,
      notMore: false,
      dbReports: [],
      algoriaPage: 1
    }, () => {
      if (this.state.algolia) {
        this.getReportsA(this.props, true, this.state.searchwordA);
      } else {
        this.getReports(this.props, true);
      }
    });
  }

  clearFilter = () => {
    this.setState({
      searchwordA: '',
      notMore: false,
      sortType: 'desc',
      reportsType: '1',
      last: null,
      dbReports: [],
      algolia: false,
      algoriaPage: 1
    }, () => {
      if (this.state.algolia) {
        this.getReportsA(this.props, true, this.state.searchwordA);
      } else {
        this.getReports(this.props, true);
      }
    });
  }
  onCellPreparedHandler = (e) => {
    if (e.rowType === 'header') {
      e.cellElement.wordWrapEnabled = true;
      e.cellElement.style.color = "#fff";
      e.cellElement.style.alignment = "middle";
      e.cellElement.style.verticalAlign = "middle";
      e.cellElement.style.backgroundColor = "#2E75B6";
      // e.cellElement.style.alignSelf = "center";
    }
    if (e.rowType === 'data') {
      e.cellElement.style.verticalAlign = "middle";
    }

  }
  onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'data') {
          //console.log('gridCell', gridCell,window.location);
          if (gridCell.column.dataField === '詳細') {
            excelCell.value = { text: '表示',hyperlink:window.location.origin + '/order/' + gridCell.data.id};
            excelCell.font = { color: { argb: '2bbbad' }, underline: true };
            excelCell.alignment = { horizontal: 'left' };
          }
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'ReportList' + firebase.firestore.Timestamp.now().toDate() + '.xlsx');
      });
    });
    e.cancel = true;
  }
  render() {
    if (!this.props.org) {
      return (
          <>
            取引先を選択してください。
          </>
      )
    }

    let kaigawa = false;
    let urigawa = false;
    if ( (this.props.userOrg && this.props.userOrg.buyer && this.props.org && this.props.org.reseller)
        || (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.maker)
    ){
      kaigawa = true;
    }
    if ( (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.buyer)
        || (this.props.userOrg && this.props.userOrg.maker && this.props.org && this.props.org.reseller)
    ){
      urigawa = true;
    }

    if(! kaigawa && ! urigawa){
      return (
          <>
          </>
      )
    }

    const reports = [];

    function n(n){
      return n > 9 ? "" + n: "0" + n;
    }

    console.log('this.state.dbReports', this.state.dbReports);
    this.state.dbReports.forEach((report,index) => {
      let created;
      let confirmDate = '';
      let startDate = '';

      if (this.state.algolia) {
        let cDate = new Date(report['created']._seconds * 1000 + report['created']._nanoseconds/1000000);
        created = cDate.getFullYear() + '/'
            + n(cDate.getMonth()+1) + '/'
            + n(cDate.getDate()) + ' '
            + n(cDate.getHours()) + ":"
            + n(cDate.getMinutes());

        if (report['confirmDate']) {
          let coDate = new Date(report['confirmDate']._seconds * 1000 + report['confirmDate']._nanoseconds/1000000);
          confirmDate = coDate.getFullYear() + '/'
              + n(coDate.getMonth()+1) + '/'
              + n(coDate.getDate()) + ' '
              + n(coDate.getHours()) + ":"
              + n(coDate.getMinutes());
        }

        if (report['date']) {
          let dDate = new Date(report['date']._seconds * 1000 + report['date']._nanoseconds/1000000);
          startDate = dDate.getFullYear() + '/'
              + n(dDate.getMonth()+1) + '/'
              + n(dDate.getDate());
        }
      } else {
        created = report['created'].toDate().getFullYear() + '/'
            + n(report['created'].toDate().getMonth()+1) + '/'
            + n(report['created'].toDate().getDate()) + ' '
            + n(report['created'].toDate().getHours()) + ":"
            + n(report['created'].toDate().getMinutes());

        if (report['confirmDate']) {
          confirmDate = report['confirmDate'].toDate().getFullYear() + '/'
              + n(report['confirmDate'].toDate().getMonth()+1) + '/'
              + n(report['confirmDate'].toDate().getDate()) + ' '
              + n(report['confirmDate'].toDate().getHours()) + ":"
              + n(report['confirmDate'].toDate().getMinutes());
        }

        if (report['date']) {
          startDate = report['date'].toDate().getFullYear() + '/'
              + n(report['date'].toDate().getMonth()+1) + '/'
              + n(report['date'].toDate().getDate());
        }
      }

      let visited = '';
      if(urigawa) {
        if (report['visited'] && report['visited'][report['toUser']] || report['confirmDate']) { //[estimates2['toUser']]
          visited = <>{report['confirmUserName'] && <><span className="text-nowrap">{report['confirmUserName']}</span><br/></>}<MDBChip className="text-nowrap disabled">確認済</MDBChip></>;
        } else {
          visited = <MDBChip bgColor="danger-color" text="white" className="text-nowrap disabled">未確認</MDBChip>;
        }
      }

      if ( kaigawa ){
        if(report['visited'] && report['visited'][this.props.user.id] || report['confirmDate']) { //[this.props.user.id]
          visited = <>{report['confirmUserName'] && <><span className="text-nowrap">{report['confirmUserName']}</span><br/></>}<MDBChip className="text-nowrap disabled">確認済</MDBChip></>;
        } else {
          visited = <MDBChip bgColor="danger-color" text="white" className="text-nowrap disabled">未確認</MDBChip>;
        }
      }

      let bold;
      if (urigawa) {
        bold = report['readSeller'] === false
      }

      if (kaigawa) {
        bold = report['readBuyer'] === false
      }
      let data = {
        'id':report['id'],
        'deleted':report['deleted'],
        'idText': report['number']!==undefined && report['number'].concat('\n' + report['id']),
        '請求番号':<span style={{fontWeight: bold ? 'bold' : ''}} className="text-nowrap">{report['number']}<br/>{report['id']}</span>,
        '送信者': <span style={{fontWeight: bold ? 'bold' : ''}} className="text-nowrap">{report['fromUserName']}<br/>{created}</span>,
        '送信者Text': report['fromUserName'].concat('\n' + created),
        '見積受取者': <span style={{fontWeight: bold ? 'bold' : ''}} className="text-nowrap">{report['toUserName']}</span>,
        '見積受取者Text': report['toUserName'],
        '確認日時': <span>{visited}<br/>{confirmDate}</span>,
        //'確認日時Text': visited.concat('\n' + confirmDate),
        '発行日': <span style={{fontWeight: bold ? 'bold' : ''}} className={'text-nowrap'}>{startDate}</span>,
        '発行日Text': startDate,
        'タイトル': <div style={{fontWeight: bold ? 'bold' : '' }}>{report['title']}</div>,
        'タイトルText': report['title'],
        '詳細': <StorageLink src={report['file']} storage={this.props.storage} target="_blank"><MDBChip bgColor="default-color" text="white" size="sm4" className="text-nowrap" data-id={report.id} data-urigawa={urigawa} data-index={index} onClick={this.openFile} >表示</MDBChip></StorageLink>,
        '詳細Text': '表示',
        // '内容表示': <StorageLink src={report['file']} storage={this.props.storage} target="_blank"><MDBChip bgColor="default-color" text="white" size="sm4" className="text-nowrap" data-id={report.id} onClick={this.openFile} >内容表示</MDBChip></StorageLink>,
      };

      if (urigawa) {
        if (report.deleted) {
          data['確認'] = <div style={{textAlign: 'center'}}>
            <MDBChip className="text-nowrap disabled custom-button-gray" style={{margin: '0 auto'}}>削除済</MDBChip>
          </div>
        } else {
          data['確認else'] = <div style={{textAlign: 'center'}}>
            <MDBBtn rounded flat size="sm"
                    data-id={report.id}
                    data-title={report['title']}
                    onClick={this.delete}
            >
              <MDBIcon
                  icon="trash"
                  size={'2x'}
                  className="custom-text-grey"/>
            </MDBBtn>
          </div>
        }

      }

      reports.push(data);
      this.state.loading && this.dataGrid.instance.pageIndex(this.dataGrid.instance.pageCount());
    });
/*

    const data = {
      columns: [
        {
          label: <div><row>報告書番号</row><br/><row>報告書ID</row></div>,
          field: '報告書番号',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>送信者</row><br/><row>送信日時</row></div>,
          field: '送信者',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: '報告受取者',
          field: '報告受取者',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>報告書確認者</row><br/><row>確認日時</row></div>,
          field: '確認日時',
          sort: 'disabled',
          width: 80,
          minimal: 'sm'
        },
        {
          label: <div><row>発行日</row></div>,
          field: '発行日',
          sort: 'asc',
          width: 80,
          minimal: 'sm'
        },
        {
          label: '報告書タイトル',
          field: '報告書タイトル',
          sort: 'disabled',
          width: 370,
          minimal: 'sm'
        },
        {
          label: '詳細',
          field: '詳細',
          sort: 'disabled',
          width: 50,
          minimal: 'sm'
        }
      ],
      rows: reports
    }
*/

   /* if(urigawa) {
      data.columns.push({
        label: <div style={{textAlign: 'center'}}>削除</div>,
        field: '削除',
        sort: 'disabled',
        width: 50,
        minimal: 'sm'
      });
    }*/

    let selectOption = <>
      <option value={1}>送信済一覧</option>
      <option value={2}>削除済一覧</option>
      <option value={3}>すべて</option>
    </>

    return (
      <>
      <h2>報告書一覧</h2>
        <MDBRow>
          <MDBCol md="3">
            <div className="input-group md-form form-sm form-1 pl-0">
              <div className="input-group-prepend">
                <span className="input-group-text lighten-3" id="basic-text1">
                  <MDBIcon className="text-white" icon="search" />
                </span>
              </div>
              <input
                  className="form-control my-0 py-1"
                  type="text"
                  placeholder="文字列検索"
                  aria-label="文字列検索"
                  onChange={this.handleSearchwordAChange}
                  onKeyDown={this.handleSearchwordAKeyDown}
                  value={this.state.searchwordA}
              />
            </div>
          </MDBCol>
          <MDBCol md={'9'} style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end', color: '#495057'}}>
            <div>
              <label style={{margin: 0}}>発行日順で並べ替え：</label>
              <div className="form-check form-check-inline">
                <input type="radio" className="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
                       checked={this.state.sortType === 'asc'} onClick={() => this.sortChange('asc')}/>
                <label className="form-check-label" htmlFor="materialInline1">昇順</label>
              </div>

              <div className="form-check form-check-inline">
                <input type="radio" className="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
                       checked={this.state.sortType === 'desc'} onClick={() => this.sortChange('desc')}/>
                <label className="form-check-label" htmlFor="materialInline2">降順</label>
              </div>

              {
                  urigawa && <>
                    <div className="form-check form-check-inline" style={{marginLeft: 20}}>
                      表示
                    </div>

                    <div className="form-check form-check-inline">
                      <select className="browser-default custom-select" value={this.state.reportsType} onChange={(e) => this.selectReportsType(e)}>
                        {selectOption}
                      </select>
                    </div>

                    <div className={'form-check form-check-inline'}>
                      <MDBBtn
                          color="default" style={{padding: 10}} flat={true} outline={true} onClick={() => this.clearFilter()}>
                        リセット
                      </MDBBtn>
                    </div>
                  </>
              }
            </div>
          </MDBCol>
        </MDBRow>
        <div id="wrapper1" style={{height: 20, overflow: 'auto'}}>
          <div id="div1" style={{height: 20}}>
          </div>
        </div>
      {/*<MDBTable responsive btn small id={"div2"}>
        <MDBTableHead color="primary-color" textWhite columns={data.columns} />
        <MDBTableBody rows={data.rows} />
      </MDBTable>*/}
        <DataGrid id={"div2"}
                  keyExpr="id"
                  noDataText="No Data"
                  dataSource={reports}
                  allowColumnResizing={true}
                  wordWrapEnabled={true}
                  ref={(ref) => (this.dataGrid = ref)}
                  columnAutoWidth={true}
                  style={{alignment: 'center', alignItems: 'center'}}
                  width={'100%'}
                  showBorders={false} sorting={{ascendingText:'昇順',descendingText:'降順',clearText:'並び替え解除'}}
                  showColumnLines={false}
                  showRowLines={true}
                  paging={{true: true,pageSize:this.state.reportPerPage}}// renderAsync={true
                  onCellPrepared={this.onCellPreparedHandler}
                  onExporting={this.onExporting}
        >     <Export enabled={true} allowExportSelectedData={false} texts={{exportAll:'すべてのデータを Excel にエクスポートする'}}/>
          <Sorting mode="none" />
          <Scrolling
              mode={'standard'} showScrollbar={'always'} useNative={'false'}
              renderAsync={true}
              preloadEnabled = {true} rowRenderingMode={'virtual'} columnRenderingMode={'virtual'}
          />
          <ColumnChooser
              enabled={true} height={"80%"} allowSearch={true}
              mode="select" title={'列セレクター'}>
            <ColumnChooserSearch
                editorOptions={{ placeholder: '見出し検索', mode: 'text'}}
                enabled={true}
                timeout={800}
            />
          </ColumnChooser>
          <ColumnFixing enabled={true} texts={{fix:'固定',leftPosition:'最左列に',rightPosition:'最右列に',unfix:'固定解除'}}/>
          <FilterRow visible={true} operationDescriptions={{contains:'次の語を含む',notContains:'次の語を含まない',startsWith:'次の語から始まる',endsWith:'次の語で終わる',equal:'等しい',notEqual:'等しくない',}} resetOperationText={'リセット'} />
          <Pager
              visible={!this.state.loading ? true : false}
              allowedPageSizes={[12]}
              displayMode={'full'}
              //showPageSizeSelector={true}
              showInfo={true}
              infoText={`{0}/{1} ページ (全 {2} 注文)`}
              showNavigationButtons={true}/>
          <Paging enabled={true}/>
          <Column
              alignment="center"
              caption={'報告書ID'}
              dataField={'idText'}
              width={180} allowSorting={true} allowFiltering={true}
              renderAsync={true}
              headerCellRender={() => {
                return <div><row>報告書番号</row><br/><row>報告書ID</row></div>
              }}
              cellRender={(item) => {
                return item.data['請求番号']
              }}
          />
          <Column
              alignment="center"
              caption={'送信者'}
              width={150} allowSorting={true} allowFiltering={true}
              renderAsync={true}
              dataField={'送信者Text'}
              headerCellRender={() => {
                return <div><row>送信者</row><br/><row>送信日時</row></div>
              }}
              cellRender={(item) => {
                return item.data['送信者']
              }}
          />
          <Column
              alignment="center"
              caption={'報告受取者'}
              width={170} allowSorting={true} allowFiltering={true}
              dataField={'見積受取者Text'}
              renderAsync={true}
              cellRender={(item) => {
                return item.data['見積受取者']
              }}
          />
          <Column
              alignment="center"
              caption={'確認日時'}
              width={150} allowSorting={false} allowFiltering={false}
              renderAsync={true}
              allowExporting={false}
              headerCellRender={() => {
                return <div><row>報告書確認者</row><br/><row>確認日時</row></div>
              }}
              cellRender={(item) => {
                return item.data['確認日時']
              }}
          />
          <Column
              alignment="center"
              caption={'発行日'}
              width={80} allowSorting={true} allowFiltering={true}
              dataField={'発行日Text'}
              renderAsync={true}
              headerCellRender={() => {
                return <div><row>発行日</row></div>
              }}
              cellRender={(item) => {
                return item.data['発行日']
              }}
          />
          <Column
              alignment="center"
              caption={'報告書タイトル'}
              //width={370}
              allowSorting={true} allowFiltering={true}
              dataField={'タイトルText'}
              renderAsync={true}
              cellRender={(item) => {
                return item.data['タイトル']
              }}
          />
          <Column
              alignment="center"
              caption={'詳細'}
              width={80} allowSorting={false} allowFiltering={false}
              dataField={'詳細Text'}
              renderAsync={true}
              cellRender={(item) => {
                return item.data['詳細']
              }}
          />
          <Column
              alignment="center"
              caption={'詳細'}
              visible={urigawa ? true : false}
              showInColumnChooser={urigawa ? true : false}
              width={80} allowSorting={false} allowFiltering={false}
              renderAsync={true}
              cellRender={(item) => {
                return item.data.deleted ? item.data['確認'] : item.data['確認else']
              }}
          />
        </DataGrid>
        <div style={{display:'flex',justifyContent:'flex-end'}} hidden={this.state.notMore || reports.length < this.state.reportPerPage ? true : false}>
          <MDBBtn
              color="default" style={{padding: 10}} flat={true} outline={true}
              onClick={this.onReachEnd}>
            次のページ
          </MDBBtn>
        </div>
      {this.state.loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner /></div>}

        <MDBModal isOpen={this.state.deleteModal} toggle={this.deleteClose}>
          <MDBModalHeader toggle={this.deleteClose}>報告書削除</MDBModalHeader>
          <MDBModalBody>
            見積書「{this.state.deleteTitle}」を削除します。よろしいですか？
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn onClick={this.deleteClose} color="secondary">キャンセル</MDBBtn>
            <MDBBtn onClick={this.deleteClose} color="danger" data-id={this.state.deleteId}>削除</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </>
    )

  }
}

export default ReportTableListV2;
